import React from 'react';

import { Wrapper, Button, StartIcon, EndIcon } from './styled/CallSimulatorCallButtonStyled';

interface LocalizationLike {
    getText: (key: string) => string;
}
interface CallButtonProps {
    isCallStarted: boolean;
    sendManualCallEvent: (isStart: boolean) => void;
    localization: LocalizationLike;
}

function CallButton({ isCallStarted, sendManualCallEvent, localization }: CallButtonProps) {
    const getButtonLabel = () => {
        return localization.getText(isCallStarted ? 'call_buttons.end' : 'call_buttons.start');
    };
    const getButtonIcon = () => {
        return isCallStarted ? <EndIcon /> : <StartIcon />;
    };

    const onButtonClick = () => {
        sendManualCallEvent(!isCallStarted);
    };

    return (
        <Wrapper>
            <Button $isCallStarted={isCallStarted} onClick={onButtonClick}>
                {getButtonIcon()}
                <span>{getButtonLabel()}</span>
            </Button>
        </Wrapper>
    );
}

export default CallButton;
